<template>


  <div :id="problem.id" :class="'accordion-section'+ (problem.open?' active':'')" v-if="problem.data">
    <div class="accordion-header" @click="problem.open = !problem.open">
      <div class="accordion-title">
        <i :class="'bi '+ problem.ico"></i> {{ problem.name }}
        <span :class="'accordion-badge ' + (problem.count > 0?'success':'critical')">{{ problem.count }} tasks</span>
      </div>
      <div class="accordion-icon">▼</div>
    </div>
    <div :class="'accordion-content'+ (problem.open?' active':'')">
      <div v-if="problem.data.worker_status?.error" class="alert-box error">{{ problem.data.worker_status.error }}</div>
      <template v-else>
        <h3>🖥️ Worker'ы и очереди</h3>
        <div class="worker-grid">
          <div class="worker-card" v-for="( info, worker) in problem.data.worker_status?.details">
            <strong>{{ worker }}</strong><br>
            <span style="color: #27ae60;">● онлайн</span><br>
            📋 Активных задач: {{ info.active_tasks_count }}<br>
            📦 Очереди:
            <template v-if="info.queues">
            <span v-for="queue in info.queues" class="queue-tag">{{ queue.name }}</span>
              </template>
            <template v-else>нет данных</template>
            <br v-if="info.stats.pool">⚙️ Пул: {{ info.stats.pool.max_concurrency }} процессов
          </div>
        </div>

        <h3>📊 Статусы Celery задач</h3>
        <div class="metric-group">
          <div class="metric-item" v-for="stat in problem.data.status_stats">
            <div><span class="status-badge status-{{ stat.status }}">{{ stat.status }}</span></div>
            <div class="metric-value">{{ stat.count }}</div>
          </div>
        </div>

        <h3>📋 Статистика по типам задач</h3>
        <table class="data-table">
          <thead>
          <tr>
            <th>Задача</th>
            <th>Всего</th>
            <th>✅ Успех</th>
            <th>❌ Ошибки</th>
            <th>% успеха</th>
          </tr>
          </thead>
          <tbody>
          <template v-if="problem.data.task_breakdown">
          <tr v-for="task in problem.data.task_breakdown">
            <td><code>{{ task.task_name ||"Неизвестно" }}</code></td>
            <td>{{ task.total }}</td>
            <td style="color: #27ae60;">{{ task.success }}</td>
            <td style="color: #e74c3c;">{{ task.failed }}</td>
            <td>
              <div class="progress-bar">
                <div
                    class="progress-fill success {% if task.success|divisibleby:task.total and task.success|floatformat:0 < 50 %}danger{% endif %}"
                    :style="{width: $widthratio(task.success, task.total) + '%'}"></div>
              </div>
              <small>{{$widthratio(task.success, task.total) + '%'}}</small>
            </td>
          </tr>
          </template>
          <tr v-else>
            <td colspan="5">Нет данных</td>
          </tr>

          </tbody>
        </table>
      </template>
    </div>
  </div>

</template>

<script>

export default {
  name: 'CeleryInfo',
  data() {
    return {}
  },
  props: {
    problem: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">

</style>